export default function fixArray<T>(input: T | T[]): T[] {
  if (input === null || input === undefined || (typeof input === 'object' && Object.keys(input).length === 0)) {
    return [];
  }
  return Array.isArray(input) ? input : [input];
}
